module.exports = __webpack_public_path__ + "img/Racism_Diagram.fd8544ac.png";